import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana46Div9M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1455_9088)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M580.581 741.342L601.989 788.171L682.267 749.37L660.859 702.541L580.581 741.342Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M560.515 694.514L580.584 741.343L660.862 702.542L639.455 655.713L560.515 694.514Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M537.776 646.348L560.521 694.515L639.461 655.714L619.391 608.885L537.776 646.348Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M517.698 599.52L537.767 646.349L619.383 608.886L597.976 560.719L517.698 599.52Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M497.631 551.352L517.701 599.518L597.979 560.717L576.571 513.889L497.631 551.352Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M476.228 503.186L497.636 551.352L576.576 513.889L553.83 465.723L476.228 503.186Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M454.814 456.358L476.222 503.186L553.824 465.723L532.416 418.895L454.814 456.358Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M433.411 408.19L454.819 456.356L532.421 418.893L511.013 370.727L433.411 408.19Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M413.345 358.686L433.414 409.528L511.016 370.727L489.609 322.561L413.345 358.686Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M391.93 310.518L413.338 358.684L489.602 322.559L468.195 274.393L391.93 310.518Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M371.864 261.014L391.933 310.518L468.197 274.393L446.79 226.227L371.864 261.014Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1455_9088" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1455_9088" transform="matrix(0.00183524 0 0 0.00243304 -4.48297 -3.50732)"/>
    </pattern>
    <image id="image0_1455_9088" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};